/**
 * @name 步骤条
 */
import base from '../../base';
import SpeedDials from './speedDials';
import Icon from '../../icon';

SpeedDials.install = function(Vue) {
  Vue.use(base);
  Vue.use(Icon);
  Vue.component(SpeedDials.name, SpeedDials);
};

export default SpeedDials;
